import { createFileRoute } from "@tanstack/react-router";

import { OperatorApp } from "../components/operator/OperatorApp";
import { validateOperatorWorkspaceSearch } from "../components/operator/operatorWorkspaceNavigation.route";

export const Route = createFileRoute("/_workspace")({
  component: OperatorApp,
  validateSearch: validateOperatorWorkspaceSearch,
});
